import { Car, Plane, ShoppingBag, GraduationCap, Building2, TreePine } from "lucide-react";

const advantages = [
  {
    icon: Car,
    title: "Excellent Connectivity",
    features: [
      "5 minutes to Metro Station",
      "Direct highway access",
      "Well-connected road network",
      "Dedicated bus routes"
    ]
  },
  {
    icon: Plane,
    title: "Airport Proximity",
    features: [
      "25 minutes to International Airport",
      "Express metro connectivity",
      "Dedicated airport shuttle",
      "24/7 taxi services"
    ]
  },
  {
    icon: ShoppingBag,
    title: "Retail & Entertainment",
    features: [
      "Premium shopping malls nearby",
      "Fine dining restaurants",
      "Entertainment complexes",
      "Weekend markets"
    ]
  },
  {
    icon: GraduationCap,
    title: "Educational Hubs",
    features: [
      "Top-rated schools within 2km",
      "Prestigious universities nearby",
      "Coaching institutes",
      "International schools"
    ]
  },
  {
    icon: Building2,
    title: "Business Districts",
    features: [
      "IT corridors accessibility",
      "Financial district proximity",
      "Corporate offices nearby",
      "Co-working spaces"
    ]
  },
  {
    icon: TreePine,
    title: "Green Spaces",
    features: [
      "Adjacent to city park",
      "Tree-lined boulevards",
      "Jogging tracks",
      "Natural water bodies"
    ]
  }
];

const LocationAdvantages = () => {
  return (
    <section className="py-20 bg-muted/20">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16 animate-fade-up">
          <h2 className="font-display-bold text-4xl md:text-5xl text-primary mb-6">
            Strategic Location Benefits
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Our properties are strategically located to offer the perfect blend of 
            connectivity, convenience, and quality of life for modern families.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {advantages.map((advantage, index) => {
            const IconComponent = advantage.icon;
            return (
              <div
                key={index}
                className="bg-card rounded-xl p-8 border border-border luxury-card animate-fade-up"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <div className="flex items-center mb-6">
                  <div className="flex items-center justify-center w-12 h-12 bg-luxury-muted rounded-lg mr-4">
                    <IconComponent className="h-6 w-6 text-luxury" />
                  </div>
                  <h3 className="font-display text-xl text-primary">
                    {advantage.title}
                  </h3>
                </div>

                <ul className="space-y-3">
                  {advantage.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-muted-foreground">
                      <div className="w-2 h-2 bg-luxury rounded-full mr-3 flex-shrink-0" />
                      <span className="text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-luxury/10 to-luxury-muted/20 rounded-2xl p-8 md:p-12">
            <h3 className="font-display-bold text-3xl text-primary mb-4">
              Investment Potential
            </h3>
            <p className="text-lg text-muted-foreground mb-6 max-w-2xl mx-auto">
              Properties in this area have shown consistent appreciation of 12-15% annually, 
              making it an ideal choice for both end-users and investors.
            </p>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-3xl font-display-bold text-luxury mb-2">15%</div>
                <div className="text-muted-foreground">Annual Appreciation</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-display-bold text-luxury mb-2">95%</div>
                <div className="text-muted-foreground">Occupancy Rate</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-display-bold text-luxury mb-2">₹8K</div>
                <div className="text-muted-foreground">Rental per sq ft</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationAdvantages;